import { createContext, useContext, ReactNode } from "react";
import { setTailoringMode, TailoringMode, TAILORING_ROUTES } from "@/services/appSettingsService";

interface TailoringModeCtx {
  mode: TailoringMode;
  route: string;
  setMode: (m: TailoringMode) => Promise<void>;
}

const TailoringModeContext = createContext<TailoringModeCtx>({
  mode: "fixed_duplicate",
  route: "/resume-tailoring-fixed-duplicate",
  setMode: async () => {},
});

export function TailoringModeProvider({ children }: { children: ReactNode }) {
  // HARD-WIRED: Claude Direct is the ONLY tailoring engine, permanently.
  // No admin setting, no localStorage, no Supabase fetch — every customer,
  // every session, lands on /resume-tailoring-claude-direct. (Marcus, Jul 2026)
  const mode: TailoringMode = "claude_direct";

  const handleSetMode = async (m: TailoringMode) => {
    // Keep the admin toggle writing to the DB for the record, but it no longer
    // changes where anyone lands.
    await setTailoringMode(m);
  };

  return (
    <TailoringModeContext.Provider value={{ mode, route: TAILORING_ROUTES[mode], setMode: handleSetMode }}>
      {children}
    </TailoringModeContext.Provider>
  );
}

export function useTailoringRoute() {
  return useContext(TailoringModeContext);
}
